module.exports = __webpack_public_path__ + "img/account.77f6d062.svg";